module.exports = __webpack_public_path__ + "img/00046.40016170.webp";